module.exports = __webpack_public_path__ + "static/mocity-2401bbb53d45e7a6a5a362613ad0d882.jpg";